import {Action} from '@ngrx/store';

export enum VoucherActionType {
    AddNew = '[VOUCHER] add.new',
}

export class VoucherAddNew implements Action {
    type: string = VoucherActionType.AddNew;

    constructor(public payload: {voucher: string, result: Array<{id: number, price: number, type: string}>}) {}
}
